import React, { useState, useEffect } from "react";
import { Result } from "antd";
import MainWrapper from "../../components/MainWrapper";
import { useDispatch, useSelector } from "react-redux";
import getVerifyManualTransaction, { getVerifyManualTransactionFunc, getVerifyManualTransactionSgd } from "../../redux/actions/getVerifyManualTransaction";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AlertMessageWrapper from "../../components/AlertMessageWrapper";
import ButtonWrapper from "../../components/ButtonWrapper";
import SpinerIndicatorWhiteBg from "../../components/SpinerIndicatorWhiteBg";
import { postSgdCreateTransaction } from "../../redux/actions/postQrInitManual";

const SgdTransactionInfo = (props) => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState("en");

  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  useEffect(() => {
    dispatch(getVerifyManualTransactionFunc(params.id, 'sgd'));
    let redirectionUrl = location.search?.split("=")[1];
    if (redirectionUrl !== undefined) {
      localStorage.setItem("redirectionUrl", redirectionUrl);
    }
  }, []);

  // ----------------CREATE THE TRANSACTION-------------
  useEffect(() => {
    if (verifyData) {
      let sgdTransactionParams = {
        transactionId: verifyData.trxRef,
        type: "sgd_paynow",
        amount: parseFloat(verifyData?.amount),
        sessionId: verifyData.sessionToken,
        userId: verifyData.merchantId,
      };

      dispatch(
        postSgdCreateTransaction(
          sgdTransactionParams,
          navigate,
          params.id
        )
      );
    }
  }, [verifyData]);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={error} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <MainWrapper>
        {
          isLoading || qrInitLoading ? (
            <SpinerIndicatorWhiteBg fontSize="15px" color="#000" />
          ) : (
            errorMessage()
          )
        }
      </MainWrapper>
    </div>
  );
};

export default SgdTransactionInfo;
